class LogosTicker extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupTickerSpeed = this.setupTickerSpeed.bind(this)

    this.setupTickerSpeed()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupTickerSpeed () {
    const tickerWidth = this.els.items.element.offsetWidth / 30
    this.style.setProperty('--Ticker_Speed', tickerWidth)
  }
}

if (!customElements.get('logos-ticker')) {
  customElements.define('logos-ticker', LogosTicker)
}
